import React, {useEffect, useState} from 'react';
import styles from './NewYearEvent.css'
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {eventsList, sendEventData} from "./eventSlice";

const EventApply = () => {
    const [file, setFile] = useState()
    const [phoneNumber, setPhoneNumber] = useState('')
    const drawId = useSelector(state => state.eventSlice.events[0]?.id)
    const token = useSelector(state => state.loginSlice.token)
    // const [userHasNum, setUserHasNum] = useState(false)
    const userNum = localStorage.getItem('user_number')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const fileChange = (e) => {
        setFile(e.target.files[0])
    }

    const sendImage = () => {
        let formData = new FormData()
        formData.append('images', file)
        formData.append('draw_id', drawId)
        dispatch(sendEventData({token, formData}))
        navigate('/event/success')
    }
    useEffect(() => {
        dispatch(eventsList(token))
    }, [])

    // useEffect(() => {
    //     userNum !== '' ? setUserHasNum(true) : setUserHasNum(false)
    // }, [userNum])
    return (
        <>
            <div className='content-wrapper'>
                <h1 className='apply_title'>
                    Загрузить фото
                </h1>
                <div className='apply_container'>
                    <FormControl style={{width: '380px'}}>
                        <TextField required className='apply_text-field' onChange={e => fileChange(e)} id='file'
                                   type='file'
                                   style={{display: "none"}}
                                   placeholder='Приложить фото' variant="outlined"/>
                        <TextField className='apply_text-field' type='text'
                                   value={file ? `Приложeно: ${file.name}` : ''} disabled
                                   placeholder='Приложить фото' variant="outlined"/>
                        <label htmlFor="file">
                            <div className='plus_icon-container'>
                                <span onClick={() => file ? setFile(null) : ''}
                                      className={file ? 'icon_active' : 'plus_icon'}>+</span>
                            </div>
                        </label>
                        <button className='apply_save-btn' onClick={file ? sendImage : null} variant="contained">
                            Сохранить
                        </button>
                    </FormControl>
                </div>
            </div>
        </>
    )
        ;
};

export default EventApply;